<template>
  <div class="term">
    <h2>Privacy Policy (Europe)</h2>
    <article>
      <div class="terms">
        <p>This privacy policy is applied when this service is used in the regions outside the European Economic Area and Switzerland which are covered by the General Data Protection Regulation. If this service is used in the two regions above, the collection and handling of relevant personal information will be subject to a separate privacy policy.<br>
          Note: By consenting to this Privacy Policy, you give us permission to use your data as described herein. Your consent is voluntary. However, if you do not grant consent, we will not be able to provide services to you; in this case, you cannot use seeall.ai web site service (together, "Service"). You may retrieve the terms of your consent at any time in the Service and may revoke your consent at any time by sending a message to: <span v-html="adminEmail"></span></p>
      </div>
      <div class="terms">
        <h3 class="title">SERVICE Privacy Policy</h3>
        <p>This Privacy Policy describes how 4GRIT gains access to and uses your personal information in the context of Service. Please read it carefully before agree to this privacy policy.</p>
      </div>
      <div class="terms">
        <h3>1. Introduction</h3>
        <p>4GRIT corporation and service operator (together, "4GRIT" or "we") is committed to protecting the information of those individuals who use the Service. This Privacy Policy sets out how we collect, use, and share information that we obtain as a result of your use of the Service and, in particular, sets out:</p>
        <ul>
          <li>What information 4GRIT may obtain from you and your mobile device as a result of your use of Service;</li>
          <li>How 4GRIT uses the information that it obtains;</li>
          <li>When 4GRIT shares information with others;</li>
          <li>When and why 4GRIT may need to transfer your personal information outside of Europe; and</li>
          <li>How you may control 4GRIT's use and sharing of your information.</li>
        </ul>
        <p>SERVICE may provide access to links to other services owned and operated by third parties including operating system providers and other contents and application providers. These third-party services are outside the scope of this Privacy Policy and have their own policies that apply to the collection, use and sharing of information in connection with their services. We encourage you to read those policies. 4GRIT is not responsible or liable for the privacy practices of such third parties.</p>
      </div>
      <div class="terms">
        <h3>2. What information does 4GRIT obtain?</h3>
        <p>We collect from you certain information in connection with Service, including:</p>
        <ul>
          <li>Information you provide directly to us; Information we obtain from your use of the SERVICE.</li>
        </ul>
        <p>The information that we may receive when you use your Service include both, the information that can be used to identify a person ("Personally Identifiable Information"), and the information that does not, on its own, permit direct association with any specific individual ("Non-Personally Identifiable information").</p>
        <ul>
          <li>Name</li>
          <li>Your Location (Region and Country)</li>
          <li>Job Position</li>
          <li>Industries</li>
          <li>Company Name</li>
          <li>Company Type</li>
          <li>Phone Number</li>
          <li>Work Email</li>
        </ul>
      </div>
      <div class="terms">
        <h3>3. How will 4GRIT use the information it obtains?</h3>
        <p>We use your information that is collected through the Service primarily for the following purposes:</p>
        <ul>
          <li>To deliver or provide product or solution information</li>
          <li>To contact you in response to product or solution’s purchase inquiries</li>
          <li>To deliver marketing activities and promotions that we created</li>
          <li>To deliver services;</li>
          <li>To alert you to special offers, updated information and other new products or services from other subsidiaries, or other third parties, or
            to forward promotional materials to you;</li>
          <li>To complete a transaction or service requested by you;</li>
          <li>To fulfill the terms of a promotion;</li>
          <li>To ensure the Sites are relevant to your needs;</li>
          <li>To help us create and publish content most relevant to you;</li>
          <li>To notify you about a material change to this privacy policy or the Terms of Use Agreement, if necessary;</li>
          <li>To allow you access to limited-entry areas of the Sites; and</li>
          <li>To contact you in response to sign up forms such as Contact Us or other inquiry.</li>
        </ul>
        <p>We may combine information obtained from you, including personal information, with information that you provide to us by other means, for the purposes consistent with this Privacy Policy.</p>
        <p>This means that the legal basis for us processing your information as described above will typically be one of the following:</p>
        <ul>
          <li>Your consent: where you have chosen to provide it. You have the right to withdraw your consent at any time; or</li>
          <li>Contract: where it is necessary to fulfil a contract that we have in place with you;</li>
          <li>Legitimate Interests: where it is necessary for our or our third parties’ legitimate business interests. For 4GRIT, this will include its
            interests as a consumer web solution products and service provider; or</li>
          <li>Legal Obligation: where the processing is necessary for compliance with our legal obligations.</li>
        </ul>
      </div>
      <div class="terms">
        <h3>4. Information Sharing</h3>
        <p>Affiliates and subsidiaries around the world for the purposes described in this Privacy Policy. The term ‘affiliates’ or ‘subsidiaries’ refers to group companies who may be using 4GRIT name or who has common ownership.<br>
          Please be aware that we may further share such information with the following entities:</p>
        <ul>
          <li>Third Party Service Providers. We may share your Personally Identifiable Information and Non-Personally Identifiable Information with
            third party service providers to enable Service.</li>
        </ul>
        <p>While we generally do not share the information with additional third parties, please note that in the following specific circumstances, we may further share the information with the following entities;</p>
        <ul>
          <li>Other Parties When Required by Law. As required by court order or other government or law enforcement authorities in order to
            comply with legal process or law;</li>
          <li>Other Parties in Connection with Corporate Transactions. In connection with a corporate event, such as a merger or sale of all or part of
            4GRIT’s business (including that of a division or subsidiary), where 4GRIT may need to disclose information to a potential buyer and its
            professional advisers;</li>
          <li>Other Parties When it is Necessary to Protect Our Services. In order to protect and defend our rights and property, including by way of
            legal proceedings;</li>
          <li>Other Parties When it is to Protect Any of Our Users’ Personal Safety or Property. In order to protect the personal safety or property of
            our users or the public.</li>
        </ul>
        <p>4GRIT will take commercially reasonable steps in order to ensure any such third parties treat your personal information securely.</p>
      </div>
      <div class="terms">
        <h3>5. Europe Economic Area</h3>
        <p>From time to time, we communicate with users who subscribe to our services via email or text message. For example, we may use your email address to confirm your request, to send you information about changes to our products and services, and to send notices and other disclosures as required by law. Marketing messages will be sent to you only if and to the extent you have explicitly consented to receiving such messages. You may opt out of marketing messages; please note however that it is in your interest to ensure that we are able to deliver certain non-marketing-related messages, and that we may be required to deliver certain notices to you by law. However, we provide you the opportunity to exercise an opt-out choice if you do not want to continue receiving marketing or other types of communication from us, such as emails or updates from us regarding new services and products offered on the Sites or if you do not want us to share your Personal Information with third parties. The opt-out choice may be exercised by checking or un-checking the appropriate box provided at the points where Personal Information is collected, or by contacting us at [<span v-html="adminEmail"></span>]. If you request discontinuation of marketing information, we will process your unsubscription as soon as possible, but please be aware that in some circumstances you may receive a few more messages until the unsubscription is processed, especially on the date of your unsubscription. </p>
      </div>
      <div class="terms">
        <h3>6. Transferring Information outside the Europe Economic</h3>
        <p>As a global organisation, we, our affiliates, subsidiaries, and suppliers may need to transfer your information (including your Personally Identifiable Information) outside the country where you are located, such as South Korea. This includes transferring your information outside the European Economic Area, if this is where you are located. We transfer your personal information in connection with providing this manner in order to provide you with our Service and any other purposes outlined in this Privacy Policy. You will need to provide your consent to this in order to use the Services. You should also bear in mind that the data protection laws in many of these countries may not offer the same level of protection as those in the country where you are located. However, before transferring your Personally Identifiable Information we will take steps to ensure that safeguards are put in place aimed at ensuring such information will be afforded the same level of protection. By agreeing to this Privacy-Policy you expressly consent to us and our business associates and suppliers processing your data in any jurisdiction, including, without limitation, Republic of Korea or United States in accordance with this Privacy Policy. For further information on how we handle and protect your personally information, please contact us at [<span v-html="adminEmail"></span>].</p>
      </div>
      <div class="terms">
        <h3>7. How long will 4GRIT keep my personal Information?</h3>
        <p>We will take reasonable steps to make sure that we keep your personal information for as long as is necessary for us to provide you with Service or other purposes set out in this Privacy Policy. We apply criteria to determine the appropriate retention period for different categories of personal information you provide us with. For example, we will keep information necessary to protect us in a legal claim, such as information relating to a contract, for the lifetime of the contract and up to seven years after. After this period it will be deleted or in some cases anonymized. Where we have collected the personal information based on your consent and we have no other lawful basis to continue with that processing, if you subsequently withdraw your consent then we will delete your personal information.</p>
      </div>
      <div class="terms">
        <h3>8. Cookies and other tracking technologies</h3>
        <p>When you use the Service, we may use cookies – small text files containing a string of alphanumeric characters – and other tracking technologies. We may use both session cookies and persistent cookies. A session cookie disappears after you close your browser. A persistent cookie remains after you close your browser and may be used by your browser on subsequent visits to the Service. Please note that if you choose not to accept cookies on the setting menu of browser, you may not be able to utilize certain features of the Service to their full potential.</p>
      </div>
      <div class="terms">
        <h3>9. Security</h3>
        <p>We use commercially reasonable efforts to safe guard the confidentiality and security of your personal information. Nevertheless, due to the design of the Internet, ever-changing technology, and other factors outside of our control, we cannot guarantee that communications between you and our servers will be free from unauthorized access by third parties or that we will not be subject to security breaches. We do not accept any responsibility for the disclosure of personal information due to errors in transmission or unauthorized or unlawful acts of third parties.</p>
      </div>
      <div class="terms">
        <h3>10. Protecting the Privacy of Children</h3>
        <p>Protecting the privacy of children is important to us. For that reason, the Service is not directed at or designed to attract anyone under 14 years old or the age of majority in the relevant jurisdiction. Should we learn or be notified that we have collected information from users under the age of 13 or the age of majority in the relevant jurisdiction, we will promptly delete such personal information. In certain countries where the age of majority is older than 14, we will direct our Services and only collect personal information from users meeting that age.</p>
      </div>
      <div class="terms">
        <h3>11. Changes to this Privacy Policy</h3>
        <p>This Privacy Policy may be updated by 4GRIT from time to time. If we make a material change to our Privacy Policy, we will update you via your mobile device or other means. You may be required to acknowledge or agree to the revised Privacy Policy in order to continue using the Service.</p>
      </div>
      <div class="terms">
        <h3>12. Accessing Your Information and Your Rights</h3>
        <p>Under the laws of some jurisdictions, may have the right to request access to, rectification or erasure of, the personal information 4GRIT holds about you or the right to object to or restrict certain types of processing of your personal information (or to withdraw your consent to 4GRIT processing), or to receive a machine-readable copy of your personal information. If permitted by laws, a small fee for providing you with such service may be charged. Please note that we may decline to process your requests if they are unreasonably abusive, jeopardize the privacy of others, or are extremely impractical (where permitted under applicable law). For further information or to exercise any of these rights, please contact us at [<span v-html="adminEmail"></span>].</p>
      </div>
      <div class="terms">
        <h3>13. Contacting 4GRIT about this Privacy policy</h3>
        <p>If you have any questions or comments about this Privacy Policy or 4GRIT’s processing of your personal information, please contact [<span v-html="adminEmail"></span>]. You also have the right to lodge a complaint with a data protection authority although we would encourage you to first contact us directly to resolve any concerns.</p>
      </div>
      <div class="terms">
        <h3>14. Third Party Web Sites</h3>
        <p>This statement applies solely to information collected on 4GRIT’s websites and applications. The websites and applications may contain links to other websites. We are not responsible for the privacy practices or the content of these other websites.</p>
      </div>
      <div class="terms">
        <p>Effective Date: July 2018</p>
      </div>
    </article>
  </div>
</template>

<script>
import { adminEmail } from '@/lib/utils'

export default {
  name: 'PrivacyEurope',
  computed: {
    adminEmail () {
      return `<a href="mailto:${adminEmail}">${adminEmail}</a>`
    }
  }
}
</script>

<style lang="scss" scoped>
.term {
  width: 1194px;
  padding: 0 15px;
  margin: 15px auto 0;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding: 40px 0 13px;
    display: inline-block;
    margin: 0 10px;
  }

  article {
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 20px 20px 50px;

    .terms {
      margin-bottom: 60px;

      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        border-radius: 4px;
        box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.12);
        background-color: #f5f5f5;
        font-size: 13px;
        font-weight: bold;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 5px 10px;
        margin-bottom: 30px;
      }

      p {
        font-size: 14px;
        color: #1e1e1e;
        line-height: 1.5;
        margin: 0 10px 30px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      ul {
        font-size: 14px;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 1.5;
        margin: 0 10px 30px;

        li {
          list-style: none;
          padding-left: 15px;
          margin-left: 20px;
          position: relative;

          &:before {
            content: '•';
            position: absolute;
            left: 0;
          }
        }
      }

      a {
        color: #386ae8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/term/PrivacyEurope.vue